export const changeWord = (firts, second, third, n) => {
	n %= 100;
	if (n >= 5 && n <= 20) {
	  return firts;
	}
	n %= 10;
	if (n === 1) {
	  return second;
	}
	if (n >= 2 && n <= 4) {
	  return third;
	}
	return firts;
}